/**
 * Tive API
 *
 * Contact: support@tive.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpResponse,
  HttpEvent,
  HttpContext,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { AccountMonitoringConfig } from '../model/accountMonitoringConfig';
// @ts-ignore
import { CityCountryDataItem } from '../model/cityCountryDataItem';
// @ts-ignore
import { DeviceDetails } from '../model/deviceDetails';
// @ts-ignore
import { PropertyValue } from '../model/propertyValue';
// @ts-ignore
import { Shipment } from '../model/shipment';
// @ts-ignore
import { ShipmentCommentResponseListLengthResult } from '../model/shipmentCommentResponseListLengthResult';
// @ts-ignore
import { ShipmentData } from '../model/shipmentData';
// @ts-ignore
import { ShipmentPublicShare } from '../model/shipmentPublicShare';
// @ts-ignore
import { ShipmentReportShipAddress } from '../model/shipmentReportShipAddress';
// @ts-ignore
import { ShipmentSearch } from '../model/shipmentSearch';
// @ts-ignore
import { ShipmentState } from '../model/shipmentState';
// @ts-ignore
import { ShipmentStatus } from '../model/shipmentStatus';
// @ts-ignore
import { ShipmentUserConfigurationEntry } from '../model/shipmentUserConfigurationEntry';
// @ts-ignore
import { User } from '../model/user';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';
import { BaseService } from '../api.base.service';

@Injectable({
  providedIn: 'root',
})
export class ShipmentsService extends BaseService {
  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration?: Configuration,
  ) {
    super(basePath, configuration);
  }

  /**
   * Get the owning account name for a specified shipment (Resource Permissions Required: ShipmentsViewAccess)
   * @endpoint get /api/shipments/accountName/{internalShipmentId}
   * @param internalShipmentId
   * @param xTiveAccountId Account Id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiShipmentsAccountNameInternalShipmentIdGet(
    internalShipmentId: string,
    xTiveAccountId?: number,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<string>;
  public apiShipmentsAccountNameInternalShipmentIdGet(
    internalShipmentId: string,
    xTiveAccountId?: number,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<string>>;
  public apiShipmentsAccountNameInternalShipmentIdGet(
    internalShipmentId: string,
    xTiveAccountId?: number,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<string>>;
  public apiShipmentsAccountNameInternalShipmentIdGet(
    internalShipmentId: string,
    xTiveAccountId?: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    if (internalShipmentId === null || internalShipmentId === undefined) {
      throw new Error(
        'Required parameter internalShipmentId was null or undefined when calling apiShipmentsAccountNameInternalShipmentIdGet.',
      );
    }

    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept([
        'application/json;odata.metadata=minimal;odata.streaming=true',
        'application/json;odata.metadata=minimal;odata.streaming=false',
        'application/json;odata.metadata=minimal',
        'application/json;odata.metadata=full;odata.streaming=true',
        'application/json;odata.metadata=full;odata.streaming=false',
        'application/json;odata.metadata=full',
        'application/json;odata.metadata=none;odata.streaming=true',
        'application/json;odata.metadata=none;odata.streaming=false',
        'application/json;odata.metadata=none',
        'application/json;odata.streaming=true',
        'application/json;odata.streaming=false',
        'application/json',
        'application/xml',
        'text/plain',
        'application/octet-stream',
        'text/json',
      ]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/shipments/accountName/${this.configuration.encodeParam({ name: 'internalShipmentId', value: internalShipmentId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<string>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * Get active shipments list (Resource Permissions Required: ShipmentsView)
   * @endpoint get /api/shipments/active
   * @param fromCity
   * @param toCity
   * @param pageNumber
   * @param xTiveAccountId Account Id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiShipmentsActiveGet(
    fromCity?: string,
    toCity?: string,
    pageNumber?: number,
    xTiveAccountId?: number,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<Array<Shipment>>;
  public apiShipmentsActiveGet(
    fromCity?: string,
    toCity?: string,
    pageNumber?: number,
    xTiveAccountId?: number,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<Array<Shipment>>>;
  public apiShipmentsActiveGet(
    fromCity?: string,
    toCity?: string,
    pageNumber?: number,
    xTiveAccountId?: number,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<Array<Shipment>>>;
  public apiShipmentsActiveGet(
    fromCity?: string,
    toCity?: string,
    pageNumber?: number,
    xTiveAccountId?: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'fromCity',
      <any>fromCity,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'toCity',
      <any>toCity,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'pageNumber',
      <any>pageNumber,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept([
        'application/json;odata.metadata=minimal;odata.streaming=true',
        'application/json;odata.metadata=minimal;odata.streaming=false',
        'application/json;odata.metadata=minimal',
        'application/json;odata.metadata=full;odata.streaming=true',
        'application/json;odata.metadata=full;odata.streaming=false',
        'application/json;odata.metadata=full',
        'application/json;odata.metadata=none;odata.streaming=true',
        'application/json;odata.metadata=none;odata.streaming=false',
        'application/json;odata.metadata=none',
        'application/json;odata.streaming=true',
        'application/json;odata.streaming=false',
        'application/json',
        'application/xml',
        'text/plain',
        'application/octet-stream',
        'text/json',
      ]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/shipments/active`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<Array<Shipment>>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters.toHttpParams(),
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * Sets alert profiles for the specified shipment (Resource Permissions Required: ShipmentsAssignAlerts)
   * @endpoint put /api/shipments/alertProfiles
   * @param xTiveAccountId Account Id
   * @param shipmentData
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiShipmentsAlertProfilesPut(
    xTiveAccountId?: number,
    shipmentData?: ShipmentData,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<any>;
  public apiShipmentsAlertProfilesPut(
    xTiveAccountId?: number,
    shipmentData?: ShipmentData,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<any>>;
  public apiShipmentsAlertProfilesPut(
    xTiveAccountId?: number,
    shipmentData?: ShipmentData,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<any>>;
  public apiShipmentsAlertProfilesPut(
    xTiveAccountId?: number,
    shipmentData?: ShipmentData,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json;odata.metadata=minimal;odata.streaming=true',
      'application/json;odata.metadata=minimal;odata.streaming=false',
      'application/json;odata.metadata=minimal',
      'application/json;odata.metadata=full;odata.streaming=true',
      'application/json;odata.metadata=full;odata.streaming=false',
      'application/json;odata.metadata=full',
      'application/json;odata.metadata=none;odata.streaming=true',
      'application/json;odata.metadata=none;odata.streaming=false',
      'application/json;odata.metadata=none',
      'application/json;odata.streaming=true',
      'application/json;odata.streaming=false',
      'application/json',
      'application/xml',
      'text/plain',
      'application/json-patch+json',
      'text/json',
      'application/*+json',
    ];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/shipments/alertProfiles`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<any>('put', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: shipmentData,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * End point which takes a csv file for shipment creation in bulk (Role Permissions Required: ShipmentsCreate; FlagsCanPreviewCsvShipments)
   * @endpoint post /api/shipments/bulkCreation
   * @param xTiveAccountId Account Id
   * @param batchShipmentCsvFile
   * @param commaDelimAlertPresetIds
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiShipmentsBulkCreationPost(
    xTiveAccountId?: number,
    batchShipmentCsvFile?: Blob,
    commaDelimAlertPresetIds?: string,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<any>;
  public apiShipmentsBulkCreationPost(
    xTiveAccountId?: number,
    batchShipmentCsvFile?: Blob,
    commaDelimAlertPresetIds?: string,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<any>>;
  public apiShipmentsBulkCreationPost(
    xTiveAccountId?: number,
    batchShipmentCsvFile?: Blob,
    commaDelimAlertPresetIds?: string,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<any>>;
  public apiShipmentsBulkCreationPost(
    xTiveAccountId?: number,
    batchShipmentCsvFile?: Blob,
    commaDelimAlertPresetIds?: string,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    // to determine the Content-Type header
    const consumes: string[] = ['multipart/form-data'];

    const canConsumeForm = this.canConsumeForm(consumes);

    let localVarFormParams: { append(param: string, value: any): any };
    let localVarUseForm = false;
    let localVarConvertFormParamsToString = false;
    // use FormData to transmit files using content-type "multipart/form-data"
    // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
    localVarUseForm = canConsumeForm;
    if (localVarUseForm) {
      localVarFormParams = new FormData();
    } else {
      localVarFormParams = new HttpParams({ encoder: this.encoder });
    }

    if (batchShipmentCsvFile !== undefined) {
      localVarFormParams =
        (localVarFormParams.append('BatchShipmentCsvFile', <any>batchShipmentCsvFile) as any) ||
        localVarFormParams;
    }
    if (commaDelimAlertPresetIds !== undefined) {
      localVarFormParams =
        (localVarFormParams.append(
          'CommaDelimAlertPresetIds',
          <any>commaDelimAlertPresetIds,
        ) as any) || localVarFormParams;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/shipments/bulkCreation`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<any>('post', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: localVarConvertFormParamsToString ? localVarFormParams.toString() : localVarFormParams,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * Check if a shipment with a ShipmentId from the provided list as parameter exists (Resource Permissions Required: ShipmentsView)
   * @endpoint post /api/shipments/bulk-shipment-exists
   * @param xTiveAccountId Account Id
   * @param requestBody
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiShipmentsBulkShipmentExistsPost(
    xTiveAccountId?: number,
    requestBody?: Array<string>,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<Array<string>>;
  public apiShipmentsBulkShipmentExistsPost(
    xTiveAccountId?: number,
    requestBody?: Array<string>,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<Array<string>>>;
  public apiShipmentsBulkShipmentExistsPost(
    xTiveAccountId?: number,
    requestBody?: Array<string>,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<Array<string>>>;
  public apiShipmentsBulkShipmentExistsPost(
    xTiveAccountId?: number,
    requestBody?: Array<string>,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept([
        'application/json;odata.metadata=minimal;odata.streaming=true',
        'application/json;odata.metadata=minimal;odata.streaming=false',
        'application/json;odata.metadata=minimal',
        'application/json;odata.metadata=full;odata.streaming=true',
        'application/json;odata.metadata=full;odata.streaming=false',
        'application/json;odata.metadata=full',
        'application/json;odata.metadata=none;odata.streaming=true',
        'application/json;odata.metadata=none;odata.streaming=false',
        'application/json;odata.metadata=none',
        'application/json;odata.streaming=true',
        'application/json;odata.streaming=false',
        'application/json',
        'application/xml',
        'text/plain',
        'application/octet-stream',
        'text/json',
      ]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json;odata.metadata=minimal;odata.streaming=true',
      'application/json;odata.metadata=minimal;odata.streaming=false',
      'application/json;odata.metadata=minimal',
      'application/json;odata.metadata=full;odata.streaming=true',
      'application/json;odata.metadata=full;odata.streaming=false',
      'application/json;odata.metadata=full',
      'application/json;odata.metadata=none;odata.streaming=true',
      'application/json;odata.metadata=none;odata.streaming=false',
      'application/json;odata.metadata=none',
      'application/json;odata.streaming=true',
      'application/json;odata.streaming=false',
      'application/json',
      'application/xml',
      'text/plain',
      'application/json-patch+json',
      'text/json',
      'application/*+json',
    ];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/shipments/bulk-shipment-exists`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<Array<string>>('post', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: requestBody,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * Search shipments by state (Resource Permissions Required: ShipmentsView)
   * @endpoint get /api/shipments/byState
   * @param states
   * @param fromCity
   * @param toCity
   * @param pageNumber
   * @param includeLegs
   * @param xTiveAccountId Account Id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiShipmentsByStateGet(
    states?: Array<ShipmentState>,
    fromCity?: string,
    toCity?: string,
    pageNumber?: number,
    includeLegs?: boolean,
    xTiveAccountId?: number,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<Array<Shipment>>;
  public apiShipmentsByStateGet(
    states?: Array<ShipmentState>,
    fromCity?: string,
    toCity?: string,
    pageNumber?: number,
    includeLegs?: boolean,
    xTiveAccountId?: number,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<Array<Shipment>>>;
  public apiShipmentsByStateGet(
    states?: Array<ShipmentState>,
    fromCity?: string,
    toCity?: string,
    pageNumber?: number,
    includeLegs?: boolean,
    xTiveAccountId?: number,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<Array<Shipment>>>;
  public apiShipmentsByStateGet(
    states?: Array<ShipmentState>,
    fromCity?: string,
    toCity?: string,
    pageNumber?: number,
    includeLegs?: boolean,
    xTiveAccountId?: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'states',
      <any>states,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'fromCity',
      <any>fromCity,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'toCity',
      <any>toCity,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'pageNumber',
      <any>pageNumber,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'includeLegs',
      <any>includeLegs,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept([
        'application/json;odata.metadata=minimal;odata.streaming=true',
        'application/json;odata.metadata=minimal;odata.streaming=false',
        'application/json;odata.metadata=minimal',
        'application/json;odata.metadata=full;odata.streaming=true',
        'application/json;odata.metadata=full;odata.streaming=false',
        'application/json;odata.metadata=full',
        'application/json;odata.metadata=none;odata.streaming=true',
        'application/json;odata.metadata=none;odata.streaming=false',
        'application/json;odata.metadata=none',
        'application/json;odata.streaming=true',
        'application/json;odata.streaming=false',
        'application/json',
        'application/xml',
        'text/plain',
        'application/octet-stream',
        'text/json',
      ]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/shipments/byState`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<Array<Shipment>>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters.toHttpParams(),
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * Get a list of carrier property values (Role Permissions Required: CarriersView)
   * @endpoint get /api/shipments/carriers
   * @param xTiveAccountId Account Id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiShipmentsCarriersGet(
    xTiveAccountId?: number,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<Array<PropertyValue>>;
  public apiShipmentsCarriersGet(
    xTiveAccountId?: number,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<Array<PropertyValue>>>;
  public apiShipmentsCarriersGet(
    xTiveAccountId?: number,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<Array<PropertyValue>>>;
  public apiShipmentsCarriersGet(
    xTiveAccountId?: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept([
        'application/json;odata.metadata=minimal;odata.streaming=true',
        'application/json;odata.metadata=minimal;odata.streaming=false',
        'application/json;odata.metadata=minimal',
        'application/json;odata.metadata=full;odata.streaming=true',
        'application/json;odata.metadata=full;odata.streaming=false',
        'application/json;odata.metadata=full',
        'application/json;odata.metadata=none;odata.streaming=true',
        'application/json;odata.metadata=none;odata.streaming=false',
        'application/json;odata.metadata=none',
        'application/json;odata.streaming=true',
        'application/json;odata.streaming=false',
        'application/json',
        'application/xml',
        'text/plain',
        'application/octet-stream',
        'text/json',
      ]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/shipments/carriers`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<Array<PropertyValue>>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * Complete shipment (Resource Permissions Required: ShipmentsView &amp;&amp; ShipmentsCompleteAction)
   * @endpoint put /api/shipments/complete
   * @param internalShipmentId
   * @param completeAtUtc
   * @param xTiveAccountId Account Id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiShipmentsCompletePut(
    internalShipmentId?: string,
    completeAtUtc?: string,
    xTiveAccountId?: number,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<boolean>;
  public apiShipmentsCompletePut(
    internalShipmentId?: string,
    completeAtUtc?: string,
    xTiveAccountId?: number,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<boolean>>;
  public apiShipmentsCompletePut(
    internalShipmentId?: string,
    completeAtUtc?: string,
    xTiveAccountId?: number,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<boolean>>;
  public apiShipmentsCompletePut(
    internalShipmentId?: string,
    completeAtUtc?: string,
    xTiveAccountId?: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'internalShipmentId',
      <any>internalShipmentId,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'completeAtUtc',
      <any>completeAtUtc,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept([
        'application/json;odata.metadata=minimal;odata.streaming=true',
        'application/json;odata.metadata=minimal;odata.streaming=false',
        'application/json;odata.metadata=minimal',
        'application/json;odata.metadata=full;odata.streaming=true',
        'application/json;odata.metadata=full;odata.streaming=false',
        'application/json;odata.metadata=full',
        'application/json;odata.metadata=none;odata.streaming=true',
        'application/json;odata.metadata=none;odata.streaming=false',
        'application/json;odata.metadata=none',
        'application/json;odata.streaming=true',
        'application/json;odata.streaming=false',
        'application/json',
        'application/xml',
        'text/plain',
        'application/octet-stream',
        'text/json',
      ]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/shipments/complete`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<boolean>('put', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters.toHttpParams(),
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * Complete bulk shipments (Resource Permissions Required: ShipmentsView &amp;&amp; ShipmentsCompleteAction)
   * @endpoint put /api/shipments/complete-shipments
   * @param xTiveAccountId Account Id
   * @param requestBody
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiShipmentsCompleteShipmentsPut(
    xTiveAccountId?: number,
    requestBody?: Array<string>,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<boolean>;
  public apiShipmentsCompleteShipmentsPut(
    xTiveAccountId?: number,
    requestBody?: Array<string>,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<boolean>>;
  public apiShipmentsCompleteShipmentsPut(
    xTiveAccountId?: number,
    requestBody?: Array<string>,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<boolean>>;
  public apiShipmentsCompleteShipmentsPut(
    xTiveAccountId?: number,
    requestBody?: Array<string>,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept([
        'application/json;odata.metadata=minimal;odata.streaming=true',
        'application/json;odata.metadata=minimal;odata.streaming=false',
        'application/json;odata.metadata=minimal',
        'application/json;odata.metadata=full;odata.streaming=true',
        'application/json;odata.metadata=full;odata.streaming=false',
        'application/json;odata.metadata=full',
        'application/json;odata.metadata=none;odata.streaming=true',
        'application/json;odata.metadata=none;odata.streaming=false',
        'application/json;odata.metadata=none',
        'application/json;odata.streaming=true',
        'application/json;odata.streaming=false',
        'application/json',
        'application/xml',
        'text/plain',
        'application/octet-stream',
        'text/json',
      ]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json;odata.metadata=minimal;odata.streaming=true',
      'application/json;odata.metadata=minimal;odata.streaming=false',
      'application/json;odata.metadata=minimal',
      'application/json;odata.metadata=full;odata.streaming=true',
      'application/json;odata.metadata=full;odata.streaming=false',
      'application/json;odata.metadata=full',
      'application/json;odata.metadata=none;odata.streaming=true',
      'application/json;odata.metadata=none;odata.streaming=false',
      'application/json;odata.metadata=none',
      'application/json;odata.streaming=true',
      'application/json;odata.streaming=false',
      'application/json',
      'application/xml',
      'text/plain',
      'application/json-patch+json',
      'text/json',
      'application/*+json',
    ];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/shipments/complete-shipments`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<boolean>('put', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: requestBody,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * Get completed (Resource Permissions Required: ShipmentsView)
   * @endpoint get /api/shipments/completed
   * @param fromCity
   * @param toCity
   * @param pageNumber
   * @param xTiveAccountId Account Id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiShipmentsCompletedGet(
    fromCity?: string,
    toCity?: string,
    pageNumber?: number,
    xTiveAccountId?: number,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<Array<Shipment>>;
  public apiShipmentsCompletedGet(
    fromCity?: string,
    toCity?: string,
    pageNumber?: number,
    xTiveAccountId?: number,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<Array<Shipment>>>;
  public apiShipmentsCompletedGet(
    fromCity?: string,
    toCity?: string,
    pageNumber?: number,
    xTiveAccountId?: number,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<Array<Shipment>>>;
  public apiShipmentsCompletedGet(
    fromCity?: string,
    toCity?: string,
    pageNumber?: number,
    xTiveAccountId?: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'fromCity',
      <any>fromCity,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'toCity',
      <any>toCity,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'pageNumber',
      <any>pageNumber,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept([
        'application/json;odata.metadata=minimal;odata.streaming=true',
        'application/json;odata.metadata=minimal;odata.streaming=false',
        'application/json;odata.metadata=minimal',
        'application/json;odata.metadata=full;odata.streaming=true',
        'application/json;odata.metadata=full;odata.streaming=false',
        'application/json;odata.metadata=full',
        'application/json;odata.metadata=none;odata.streaming=true',
        'application/json;odata.metadata=none;odata.streaming=false',
        'application/json;odata.metadata=none',
        'application/json;odata.streaming=true',
        'application/json;odata.streaming=false',
        'application/json',
        'application/xml',
        'text/plain',
        'application/octet-stream',
        'text/json',
      ]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/shipments/completed`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<Array<Shipment>>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters.toHttpParams(),
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * Create a comment for the shipment (Resource Permissions Required: AddShipmentAndAlertComments)
   * @endpoint post /api/shipments/create-shipment-comment
   * @param xTiveAccountId Account Id
   * @param shipmentCommentId
   * @param internalShipmentId
   * @param comment
   * @param createdByUserId
   * @param createdAtUtc
   * @param createdByUserFirstName
   * @param createdByUserLastName
   * @param createdByUserEmail
   * @param attachments
   * @param mentionedUserIds
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiShipmentsCreateShipmentCommentPost(
    xTiveAccountId?: number,
    shipmentCommentId?: string,
    internalShipmentId?: string,
    comment?: string,
    createdByUserId?: string,
    createdAtUtc?: string,
    createdByUserFirstName?: string,
    createdByUserLastName?: string,
    createdByUserEmail?: string,
    attachments?: Array<Blob>,
    mentionedUserIds?: Array<string>,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<any>;
  public apiShipmentsCreateShipmentCommentPost(
    xTiveAccountId?: number,
    shipmentCommentId?: string,
    internalShipmentId?: string,
    comment?: string,
    createdByUserId?: string,
    createdAtUtc?: string,
    createdByUserFirstName?: string,
    createdByUserLastName?: string,
    createdByUserEmail?: string,
    attachments?: Array<Blob>,
    mentionedUserIds?: Array<string>,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<any>>;
  public apiShipmentsCreateShipmentCommentPost(
    xTiveAccountId?: number,
    shipmentCommentId?: string,
    internalShipmentId?: string,
    comment?: string,
    createdByUserId?: string,
    createdAtUtc?: string,
    createdByUserFirstName?: string,
    createdByUserLastName?: string,
    createdByUserEmail?: string,
    attachments?: Array<Blob>,
    mentionedUserIds?: Array<string>,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<any>>;
  public apiShipmentsCreateShipmentCommentPost(
    xTiveAccountId?: number,
    shipmentCommentId?: string,
    internalShipmentId?: string,
    comment?: string,
    createdByUserId?: string,
    createdAtUtc?: string,
    createdByUserFirstName?: string,
    createdByUserLastName?: string,
    createdByUserEmail?: string,
    attachments?: Array<Blob>,
    mentionedUserIds?: Array<string>,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    // to determine the Content-Type header
    const consumes: string[] = ['multipart/form-data'];

    const canConsumeForm = this.canConsumeForm(consumes);

    let localVarFormParams: { append(param: string, value: any): any };
    let localVarUseForm = false;
    let localVarConvertFormParamsToString = false;
    // use FormData to transmit files using content-type "multipart/form-data"
    // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
    localVarUseForm = canConsumeForm;
    if (localVarUseForm) {
      localVarFormParams = new FormData();
    } else {
      localVarFormParams = new HttpParams({ encoder: this.encoder });
    }

    if (shipmentCommentId !== undefined) {
      localVarFormParams =
        (localVarFormParams.append('ShipmentCommentId', <any>shipmentCommentId) as any) ||
        localVarFormParams;
    }
    if (internalShipmentId !== undefined) {
      localVarFormParams =
        (localVarFormParams.append('InternalShipmentId', <any>internalShipmentId) as any) ||
        localVarFormParams;
    }
    if (comment !== undefined) {
      localVarFormParams =
        (localVarFormParams.append('Comment', <any>comment) as any) || localVarFormParams;
    }
    if (createdByUserId !== undefined) {
      localVarFormParams =
        (localVarFormParams.append('CreatedByUserId', <any>createdByUserId) as any) ||
        localVarFormParams;
    }
    if (createdAtUtc !== undefined) {
      localVarFormParams =
        (localVarFormParams.append('CreatedAtUtc', <any>createdAtUtc) as any) || localVarFormParams;
    }
    if (createdByUserFirstName !== undefined) {
      localVarFormParams =
        (localVarFormParams.append('CreatedByUserFirstName', <any>createdByUserFirstName) as any) ||
        localVarFormParams;
    }
    if (createdByUserLastName !== undefined) {
      localVarFormParams =
        (localVarFormParams.append('CreatedByUserLastName', <any>createdByUserLastName) as any) ||
        localVarFormParams;
    }
    if (createdByUserEmail !== undefined) {
      localVarFormParams =
        (localVarFormParams.append('CreatedByUserEmail', <any>createdByUserEmail) as any) ||
        localVarFormParams;
    }
    if (attachments) {
      attachments.forEach((element) => {
        localVarFormParams =
          (localVarFormParams.append('Attachments', <any>element) as any) || localVarFormParams;
      });
    }
    if (mentionedUserIds) {
      mentionedUserIds.forEach((element) => {
        localVarFormParams =
          (localVarFormParams.append('MentionedUserIds', <any>element) as any) ||
          localVarFormParams;
      });
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/shipments/create-shipment-comment`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<any>('post', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: localVarConvertFormParamsToString ? localVarFormParams.toString() : localVarFormParams,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * Get custom fields for a customer on creating or updating shipment (Role Permissions Required: ShipmentsView)
   * @endpoint get /api/shipments/customfields
   * @param xTiveAccountId Account Id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiShipmentsCustomfieldsGet(
    xTiveAccountId?: number,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<any>;
  public apiShipmentsCustomfieldsGet(
    xTiveAccountId?: number,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<any>>;
  public apiShipmentsCustomfieldsGet(
    xTiveAccountId?: number,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<any>>;
  public apiShipmentsCustomfieldsGet(
    xTiveAccountId?: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/shipments/customfields`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<any>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * Cancel shipment (Resource Permissions Required: ShipmentsView &amp;&amp; ShipmentsDelete)
   * @endpoint delete /api/shipments
   * @param internalShipmentId
   * @param xTiveAccountId Account Id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiShipmentsDelete(
    internalShipmentId?: string,
    xTiveAccountId?: number,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<any>;
  public apiShipmentsDelete(
    internalShipmentId?: string,
    xTiveAccountId?: number,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<any>>;
  public apiShipmentsDelete(
    internalShipmentId?: string,
    xTiveAccountId?: number,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<any>>;
  public apiShipmentsDelete(
    internalShipmentId?: string,
    xTiveAccountId?: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'internalShipmentId',
      <any>internalShipmentId,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/shipments`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<any>('delete', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters.toHttpParams(),
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * Get device details for a specified shipment (Resource Permissions Required: ShipmentsView)
   * @endpoint get /api/shipments/deviceDetails/{internalShipmentId}
   * @param internalShipmentId
   * @param xTiveAccountId Account Id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiShipmentsDeviceDetailsInternalShipmentIdGet(
    internalShipmentId: string,
    xTiveAccountId?: number,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<Array<DeviceDetails>>;
  public apiShipmentsDeviceDetailsInternalShipmentIdGet(
    internalShipmentId: string,
    xTiveAccountId?: number,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<Array<DeviceDetails>>>;
  public apiShipmentsDeviceDetailsInternalShipmentIdGet(
    internalShipmentId: string,
    xTiveAccountId?: number,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<Array<DeviceDetails>>>;
  public apiShipmentsDeviceDetailsInternalShipmentIdGet(
    internalShipmentId: string,
    xTiveAccountId?: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    if (internalShipmentId === null || internalShipmentId === undefined) {
      throw new Error(
        'Required parameter internalShipmentId was null or undefined when calling apiShipmentsDeviceDetailsInternalShipmentIdGet.',
      );
    }

    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept([
        'application/json;odata.metadata=minimal;odata.streaming=true',
        'application/json;odata.metadata=minimal;odata.streaming=false',
        'application/json;odata.metadata=minimal',
        'application/json;odata.metadata=full;odata.streaming=true',
        'application/json;odata.metadata=full;odata.streaming=false',
        'application/json;odata.metadata=full',
        'application/json;odata.metadata=none;odata.streaming=true',
        'application/json;odata.metadata=none;odata.streaming=false',
        'application/json;odata.metadata=none',
        'application/json;odata.streaming=true',
        'application/json;odata.streaming=false',
        'application/json',
        'application/xml',
        'text/plain',
        'application/octet-stream',
        'text/json',
      ]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/shipments/deviceDetails/${this.configuration.encodeParam({ name: 'internalShipmentId', value: internalShipmentId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<Array<DeviceDetails>>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * Download shipment comment attachment (Resource Permissions Required: ViewShipmentAndAlertComments)
   * @endpoint get /api/shipments/download-shipment-comment-attachment
   * @param internalShipmentId
   * @param commentAttachmentId
   * @param xTiveAccountId Account Id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiShipmentsDownloadShipmentCommentAttachmentGet(
    internalShipmentId?: string,
    commentAttachmentId?: string,
    xTiveAccountId?: number,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<any>;
  public apiShipmentsDownloadShipmentCommentAttachmentGet(
    internalShipmentId?: string,
    commentAttachmentId?: string,
    xTiveAccountId?: number,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<any>>;
  public apiShipmentsDownloadShipmentCommentAttachmentGet(
    internalShipmentId?: string,
    commentAttachmentId?: string,
    xTiveAccountId?: number,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<any>>;
  public apiShipmentsDownloadShipmentCommentAttachmentGet(
    internalShipmentId?: string,
    commentAttachmentId?: string,
    xTiveAccountId?: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'internalShipmentId',
      <any>internalShipmentId,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'commentAttachmentId',
      <any>commentAttachmentId,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/shipments/download-shipment-comment-attachment`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<any>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters.toHttpParams(),
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * Duplicate shipment (Role Permissions Required: ShipmentsCreate)
   * @endpoint post /api/shipments/duplicate
   * @param internalShipmentId
   * @param xTiveAccountId Account Id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiShipmentsDuplicatePost(
    internalShipmentId?: string,
    xTiveAccountId?: number,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<any>;
  public apiShipmentsDuplicatePost(
    internalShipmentId?: string,
    xTiveAccountId?: number,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<any>>;
  public apiShipmentsDuplicatePost(
    internalShipmentId?: string,
    xTiveAccountId?: number,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<any>>;
  public apiShipmentsDuplicatePost(
    internalShipmentId?: string,
    xTiveAccountId?: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'internalShipmentId',
      <any>internalShipmentId,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/shipments/duplicate`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<any>('post', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters.toHttpParams(),
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * Get shipments [Ship From] list (Resource Permissions Required: ShipmentsView)
   * @endpoint get /api/shipments/fromlist
   * @param shipmentGroup 1 &#x3D; Upcoming, 2 &#x3D; Active, 3 &#x3D; Completed. Leave empty for all
   * @param xTiveAccountId Account Id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiShipmentsFromlistGet(
    shipmentGroup?: number,
    xTiveAccountId?: number,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<Array<CityCountryDataItem>>;
  public apiShipmentsFromlistGet(
    shipmentGroup?: number,
    xTiveAccountId?: number,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<Array<CityCountryDataItem>>>;
  public apiShipmentsFromlistGet(
    shipmentGroup?: number,
    xTiveAccountId?: number,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<Array<CityCountryDataItem>>>;
  public apiShipmentsFromlistGet(
    shipmentGroup?: number,
    xTiveAccountId?: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'shipmentGroup',
      <any>shipmentGroup,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept([
        'application/json;odata.metadata=minimal;odata.streaming=true',
        'application/json;odata.metadata=minimal;odata.streaming=false',
        'application/json;odata.metadata=minimal',
        'application/json;odata.metadata=full;odata.streaming=true',
        'application/json;odata.metadata=full;odata.streaming=false',
        'application/json;odata.metadata=full',
        'application/json;odata.metadata=none;odata.streaming=true',
        'application/json;odata.metadata=none;odata.streaming=false',
        'application/json;odata.metadata=none',
        'application/json;odata.streaming=true',
        'application/json;odata.streaming=false',
        'application/json',
        'application/xml',
        'text/plain',
        'application/octet-stream',
        'text/json',
      ]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/shipments/fromlist`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<Array<CityCountryDataItem>>(
      'get',
      `${basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters.toHttpParams(),
        responseType: <any>responseType_,
        ...(withCredentials ? { withCredentials } : {}),
        headers: localVarHeaders,
        observe: observe,
        ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Get report shipments [From City][To City] list (Resource Permissions Required: ShipmentsView)
   * @endpoint get /api/shipments/fromtolist
   * @param dateCreatedThreshold
   * @param xTiveAccountId Account Id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiShipmentsFromtolistGet(
    dateCreatedThreshold?: string,
    xTiveAccountId?: number,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<Array<ShipmentReportShipAddress>>;
  public apiShipmentsFromtolistGet(
    dateCreatedThreshold?: string,
    xTiveAccountId?: number,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<Array<ShipmentReportShipAddress>>>;
  public apiShipmentsFromtolistGet(
    dateCreatedThreshold?: string,
    xTiveAccountId?: number,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<Array<ShipmentReportShipAddress>>>;
  public apiShipmentsFromtolistGet(
    dateCreatedThreshold?: string,
    xTiveAccountId?: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'dateCreatedThreshold',
      <any>dateCreatedThreshold,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept([
        'application/json;odata.metadata=minimal;odata.streaming=true',
        'application/json;odata.metadata=minimal;odata.streaming=false',
        'application/json;odata.metadata=minimal',
        'application/json;odata.metadata=full;odata.streaming=true',
        'application/json;odata.metadata=full;odata.streaming=false',
        'application/json;odata.metadata=full',
        'application/json;odata.metadata=none;odata.streaming=true',
        'application/json;odata.metadata=none;odata.streaming=false',
        'application/json;odata.metadata=none',
        'application/json;odata.streaming=true',
        'application/json;odata.streaming=false',
        'application/json',
        'application/xml',
        'text/plain',
        'application/octet-stream',
        'text/json',
      ]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/shipments/fromtolist`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<Array<ShipmentReportShipAddress>>(
      'get',
      `${basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters.toHttpParams(),
        responseType: <any>responseType_,
        ...(withCredentials ? { withCredentials } : {}),
        headers: localVarHeaders,
        observe: observe,
        ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Get upcoming shipments (Resource Permissions Required: ShipmentsView)
   * @endpoint get /api/shipments
   * @param fromCity
   * @param toCity
   * @param pageNumber
   * @param xTiveAccountId Account Id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiShipmentsGet(
    fromCity?: string,
    toCity?: string,
    pageNumber?: number,
    xTiveAccountId?: number,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<Array<Shipment>>;
  public apiShipmentsGet(
    fromCity?: string,
    toCity?: string,
    pageNumber?: number,
    xTiveAccountId?: number,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<Array<Shipment>>>;
  public apiShipmentsGet(
    fromCity?: string,
    toCity?: string,
    pageNumber?: number,
    xTiveAccountId?: number,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<Array<Shipment>>>;
  public apiShipmentsGet(
    fromCity?: string,
    toCity?: string,
    pageNumber?: number,
    xTiveAccountId?: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'fromCity',
      <any>fromCity,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'toCity',
      <any>toCity,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'pageNumber',
      <any>pageNumber,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept([
        'application/json;odata.metadata=minimal;odata.streaming=true',
        'application/json;odata.metadata=minimal;odata.streaming=false',
        'application/json;odata.metadata=minimal',
        'application/json;odata.metadata=full;odata.streaming=true',
        'application/json;odata.metadata=full;odata.streaming=false',
        'application/json;odata.metadata=full',
        'application/json;odata.metadata=none;odata.streaming=true',
        'application/json;odata.metadata=none;odata.streaming=false',
        'application/json;odata.metadata=none',
        'application/json;odata.streaming=true',
        'application/json;odata.streaming=false',
        'application/json',
        'application/xml',
        'text/plain',
        'application/octet-stream',
        'text/json',
      ]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/shipments`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<Array<Shipment>>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters.toHttpParams(),
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * Returns the completed date of the most recent shipment which had one of the devices attached to it  If there is a still in-transit shipment, it returns [9999-12-31]  If there is no shipment for the provided trackers, it returns [0001-01-01]
   * @endpoint get /api/shipments/getLastActiveShipmentCompletedDateForDevices
   * @param deviceIds
   * @param excludedInternalShipmentId
   * @param xTiveAccountId Account Id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiShipmentsGetLastActiveShipmentCompletedDateForDevicesGet(
    deviceIds?: Array<string>,
    excludedInternalShipmentId?: string,
    xTiveAccountId?: number,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<string>;
  public apiShipmentsGetLastActiveShipmentCompletedDateForDevicesGet(
    deviceIds?: Array<string>,
    excludedInternalShipmentId?: string,
    xTiveAccountId?: number,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<string>>;
  public apiShipmentsGetLastActiveShipmentCompletedDateForDevicesGet(
    deviceIds?: Array<string>,
    excludedInternalShipmentId?: string,
    xTiveAccountId?: number,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<string>>;
  public apiShipmentsGetLastActiveShipmentCompletedDateForDevicesGet(
    deviceIds?: Array<string>,
    excludedInternalShipmentId?: string,
    xTiveAccountId?: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'deviceIds',
      <any>deviceIds,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'excludedInternalShipmentId',
      <any>excludedInternalShipmentId,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept([
        'application/json;odata.metadata=minimal;odata.streaming=true',
        'application/json;odata.metadata=minimal;odata.streaming=false',
        'application/json;odata.metadata=minimal',
        'application/json;odata.metadata=full;odata.streaming=true',
        'application/json;odata.metadata=full;odata.streaming=false',
        'application/json;odata.metadata=full',
        'application/json;odata.metadata=none;odata.streaming=true',
        'application/json;odata.metadata=none;odata.streaming=false',
        'application/json;odata.metadata=none',
        'application/json;odata.streaming=true',
        'application/json;odata.streaming=false',
        'application/json',
        'application/xml',
        'text/plain',
        'application/octet-stream',
        'text/json',
      ]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/shipments/getLastActiveShipmentCompletedDateForDevices`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<string>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters.toHttpParams(),
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * Returns list of comments for a specific shipment. Does not include alert comments or comment attachments (Resource Permissions Required: ViewShipmentAndAlertComments)
   * @endpoint get /api/shipments/get-shipment-comments-by-shipment-id
   * @param shipmentId
   * @param pageSize
   * @param pageNumber
   * @param xTiveAccountId Account Id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiShipmentsGetShipmentCommentsByShipmentIdGet(
    shipmentId?: string,
    pageSize?: number,
    pageNumber?: number,
    xTiveAccountId?: number,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<ShipmentCommentResponseListLengthResult>;
  public apiShipmentsGetShipmentCommentsByShipmentIdGet(
    shipmentId?: string,
    pageSize?: number,
    pageNumber?: number,
    xTiveAccountId?: number,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<ShipmentCommentResponseListLengthResult>>;
  public apiShipmentsGetShipmentCommentsByShipmentIdGet(
    shipmentId?: string,
    pageSize?: number,
    pageNumber?: number,
    xTiveAccountId?: number,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<ShipmentCommentResponseListLengthResult>>;
  public apiShipmentsGetShipmentCommentsByShipmentIdGet(
    shipmentId?: string,
    pageSize?: number,
    pageNumber?: number,
    xTiveAccountId?: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'shipmentId',
      <any>shipmentId,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'pageSize',
      <any>pageSize,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'pageNumber',
      <any>pageNumber,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept([
        'application/json;odata.metadata=minimal;odata.streaming=true',
        'application/json;odata.metadata=minimal;odata.streaming=false',
        'application/json;odata.metadata=minimal',
        'application/json;odata.metadata=full;odata.streaming=true',
        'application/json;odata.metadata=full;odata.streaming=false',
        'application/json;odata.metadata=full',
        'application/json;odata.metadata=none;odata.streaming=true',
        'application/json;odata.metadata=none;odata.streaming=false',
        'application/json;odata.metadata=none',
        'application/json;odata.streaming=true',
        'application/json;odata.streaming=false',
        'application/json',
        'application/xml',
        'text/plain',
        'application/octet-stream',
        'text/json',
      ]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/shipments/get-shipment-comments-by-shipment-id`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<ShipmentCommentResponseListLengthResult>(
      'get',
      `${basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters.toHttpParams(),
        responseType: <any>responseType_,
        ...(withCredentials ? { withCredentials } : {}),
        headers: localVarHeaders,
        observe: observe,
        ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Returns list of comments for a specific shipment (Resource Permissions Required: ViewShipmentAndAlertComments)
   * @endpoint get /api/shipments/get-shipment-comments
   * @param internalShipmentId
   * @param pageSize
   * @param pageNumber
   * @param xTiveAccountId Account Id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiShipmentsGetShipmentCommentsGet(
    internalShipmentId?: string,
    pageSize?: number,
    pageNumber?: number,
    xTiveAccountId?: number,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<ShipmentCommentResponseListLengthResult>;
  public apiShipmentsGetShipmentCommentsGet(
    internalShipmentId?: string,
    pageSize?: number,
    pageNumber?: number,
    xTiveAccountId?: number,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<ShipmentCommentResponseListLengthResult>>;
  public apiShipmentsGetShipmentCommentsGet(
    internalShipmentId?: string,
    pageSize?: number,
    pageNumber?: number,
    xTiveAccountId?: number,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<ShipmentCommentResponseListLengthResult>>;
  public apiShipmentsGetShipmentCommentsGet(
    internalShipmentId?: string,
    pageSize?: number,
    pageNumber?: number,
    xTiveAccountId?: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'internalShipmentId',
      <any>internalShipmentId,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'pageSize',
      <any>pageSize,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'pageNumber',
      <any>pageNumber,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept([
        'application/json;odata.metadata=minimal;odata.streaming=true',
        'application/json;odata.metadata=minimal;odata.streaming=false',
        'application/json;odata.metadata=minimal',
        'application/json;odata.metadata=full;odata.streaming=true',
        'application/json;odata.metadata=full;odata.streaming=false',
        'application/json;odata.metadata=full',
        'application/json;odata.metadata=none;odata.streaming=true',
        'application/json;odata.metadata=none;odata.streaming=false',
        'application/json;odata.metadata=none',
        'application/json;odata.streaming=true',
        'application/json;odata.streaming=false',
        'application/json',
        'application/xml',
        'text/plain',
        'application/octet-stream',
        'text/json',
      ]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/shipments/get-shipment-comments`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<ShipmentCommentResponseListLengthResult>(
      'get',
      `${basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters.toHttpParams(),
        responseType: <any>responseType_,
        ...(withCredentials ? { withCredentials } : {}),
        headers: localVarHeaders,
        observe: observe,
        ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Get shipments by Id (Resource Permissions Required: ShipmentsView)
   * @endpoint get /api/shipments/id
   * @param publicShipmentId
   * @param loadTemperatureCalculations
   * @param degreeMinutesMinTemp
   * @param degreeMinutesMaxTemp
   * @param accountId
   * @param shouldOnlySearchAccount Restrict shipment searches to the provided account id.
   * @param includeCurrentLocations If true, the saved locations which correspond to the current location will be included.
   * @param xTiveAccountId Account Id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiShipmentsIdGet(
    publicShipmentId?: string,
    loadTemperatureCalculations?: boolean,
    degreeMinutesMinTemp?: number,
    degreeMinutesMaxTemp?: number,
    accountId?: number,
    shouldOnlySearchAccount?: boolean,
    includeCurrentLocations?: boolean,
    xTiveAccountId?: number,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<Shipment>;
  public apiShipmentsIdGet(
    publicShipmentId?: string,
    loadTemperatureCalculations?: boolean,
    degreeMinutesMinTemp?: number,
    degreeMinutesMaxTemp?: number,
    accountId?: number,
    shouldOnlySearchAccount?: boolean,
    includeCurrentLocations?: boolean,
    xTiveAccountId?: number,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<Shipment>>;
  public apiShipmentsIdGet(
    publicShipmentId?: string,
    loadTemperatureCalculations?: boolean,
    degreeMinutesMinTemp?: number,
    degreeMinutesMaxTemp?: number,
    accountId?: number,
    shouldOnlySearchAccount?: boolean,
    includeCurrentLocations?: boolean,
    xTiveAccountId?: number,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<Shipment>>;
  public apiShipmentsIdGet(
    publicShipmentId?: string,
    loadTemperatureCalculations?: boolean,
    degreeMinutesMinTemp?: number,
    degreeMinutesMaxTemp?: number,
    accountId?: number,
    shouldOnlySearchAccount?: boolean,
    includeCurrentLocations?: boolean,
    xTiveAccountId?: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'publicShipmentId',
      <any>publicShipmentId,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'loadTemperatureCalculations',
      <any>loadTemperatureCalculations,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'degreeMinutesMinTemp',
      <any>degreeMinutesMinTemp,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'degreeMinutesMaxTemp',
      <any>degreeMinutesMaxTemp,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'accountId',
      <any>accountId,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'shouldOnlySearchAccount',
      <any>shouldOnlySearchAccount,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'includeCurrentLocations',
      <any>includeCurrentLocations,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept([
        'application/json;odata.metadata=minimal;odata.streaming=true',
        'application/json;odata.metadata=minimal;odata.streaming=false',
        'application/json;odata.metadata=minimal',
        'application/json;odata.metadata=full;odata.streaming=true',
        'application/json;odata.metadata=full;odata.streaming=false',
        'application/json;odata.metadata=full',
        'application/json;odata.metadata=none;odata.streaming=true',
        'application/json;odata.metadata=none;odata.streaming=false',
        'application/json;odata.metadata=none',
        'application/json;odata.streaming=true',
        'application/json;odata.streaming=false',
        'application/json',
        'application/xml',
        'text/plain',
        'application/octet-stream',
        'text/json',
      ]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/shipments/id`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<Shipment>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters.toHttpParams(),
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * Get a list of shipment objects. (Resource Permissions Required: ShipmentsView)
   * @endpoint get /api/shipments/listPaged
   * @param searchQuery
   * @param pageSize
   * @param pageNumber
   * @param loadShipmentLegs
   * @param loadTemperatureCalculations
   * @param degreeMinutesMinTemp
   * @param degreeMinutesMaxTemp
   * @param xTiveAccountId Account Id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiShipmentsListPagedGet(
    searchQuery?: string,
    pageSize?: number,
    pageNumber?: number,
    loadShipmentLegs?: boolean,
    loadTemperatureCalculations?: boolean,
    degreeMinutesMinTemp?: number,
    degreeMinutesMaxTemp?: number,
    xTiveAccountId?: number,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<any>;
  public apiShipmentsListPagedGet(
    searchQuery?: string,
    pageSize?: number,
    pageNumber?: number,
    loadShipmentLegs?: boolean,
    loadTemperatureCalculations?: boolean,
    degreeMinutesMinTemp?: number,
    degreeMinutesMaxTemp?: number,
    xTiveAccountId?: number,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<any>>;
  public apiShipmentsListPagedGet(
    searchQuery?: string,
    pageSize?: number,
    pageNumber?: number,
    loadShipmentLegs?: boolean,
    loadTemperatureCalculations?: boolean,
    degreeMinutesMinTemp?: number,
    degreeMinutesMaxTemp?: number,
    xTiveAccountId?: number,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<any>>;
  public apiShipmentsListPagedGet(
    searchQuery?: string,
    pageSize?: number,
    pageNumber?: number,
    loadShipmentLegs?: boolean,
    loadTemperatureCalculations?: boolean,
    degreeMinutesMinTemp?: number,
    degreeMinutesMaxTemp?: number,
    xTiveAccountId?: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'searchQuery',
      <any>searchQuery,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'pageSize',
      <any>pageSize,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'pageNumber',
      <any>pageNumber,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'loadShipmentLegs',
      <any>loadShipmentLegs,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'loadTemperatureCalculations',
      <any>loadTemperatureCalculations,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'degreeMinutesMinTemp',
      <any>degreeMinutesMinTemp,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'degreeMinutesMaxTemp',
      <any>degreeMinutesMaxTemp,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/shipments/listPaged`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<any>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters.toHttpParams(),
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * Checks if a shipment needs recalculation (Resource Permissions Required: ShipmentsView)
   * @endpoint post /api/shipments/needsRecalculation
   * @param xTiveAccountId Account Id
   * @param shipmentData
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiShipmentsNeedsRecalculationPost(
    xTiveAccountId?: number,
    shipmentData?: ShipmentData,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<boolean>;
  public apiShipmentsNeedsRecalculationPost(
    xTiveAccountId?: number,
    shipmentData?: ShipmentData,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<boolean>>;
  public apiShipmentsNeedsRecalculationPost(
    xTiveAccountId?: number,
    shipmentData?: ShipmentData,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<boolean>>;
  public apiShipmentsNeedsRecalculationPost(
    xTiveAccountId?: number,
    shipmentData?: ShipmentData,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept([
        'application/json;odata.metadata=minimal;odata.streaming=true',
        'application/json;odata.metadata=minimal;odata.streaming=false',
        'application/json;odata.metadata=minimal',
        'application/json;odata.metadata=full;odata.streaming=true',
        'application/json;odata.metadata=full;odata.streaming=false',
        'application/json;odata.metadata=full',
        'application/json;odata.metadata=none;odata.streaming=true',
        'application/json;odata.metadata=none;odata.streaming=false',
        'application/json;odata.metadata=none',
        'application/json;odata.streaming=true',
        'application/json;odata.streaming=false',
        'application/json',
        'application/xml',
        'text/plain',
        'application/octet-stream',
        'text/json',
      ]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json;odata.metadata=minimal;odata.streaming=true',
      'application/json;odata.metadata=minimal;odata.streaming=false',
      'application/json;odata.metadata=minimal',
      'application/json;odata.metadata=full;odata.streaming=true',
      'application/json;odata.metadata=full;odata.streaming=false',
      'application/json;odata.metadata=full',
      'application/json;odata.metadata=none;odata.streaming=true',
      'application/json;odata.metadata=none;odata.streaming=false',
      'application/json;odata.metadata=none',
      'application/json;odata.streaming=true',
      'application/json;odata.streaming=false',
      'application/json',
      'application/xml',
      'text/plain',
      'application/json-patch+json',
      'text/json',
      'application/*+json',
    ];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/shipments/needsRecalculation`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<boolean>('post', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: shipmentData,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * Register new shipment (Role Permissions Required: ShipmentsCreate)
   * @endpoint post /api/shipments
   * @param xTiveAccountId Account Id
   * @param shipmentData
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiShipmentsPost(
    xTiveAccountId?: number,
    shipmentData?: ShipmentData,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<any>;
  public apiShipmentsPost(
    xTiveAccountId?: number,
    shipmentData?: ShipmentData,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<any>>;
  public apiShipmentsPost(
    xTiveAccountId?: number,
    shipmentData?: ShipmentData,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<any>>;
  public apiShipmentsPost(
    xTiveAccountId?: number,
    shipmentData?: ShipmentData,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json;odata.metadata=minimal;odata.streaming=true',
      'application/json;odata.metadata=minimal;odata.streaming=false',
      'application/json;odata.metadata=minimal',
      'application/json;odata.metadata=full;odata.streaming=true',
      'application/json;odata.metadata=full;odata.streaming=false',
      'application/json;odata.metadata=full',
      'application/json;odata.metadata=none;odata.streaming=true',
      'application/json;odata.metadata=none;odata.streaming=false',
      'application/json;odata.metadata=none',
      'application/json;odata.streaming=true',
      'application/json;odata.streaming=false',
      'application/json',
      'application/xml',
      'text/plain',
      'application/json-patch+json',
      'text/json',
      'application/*+json',
    ];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/shipments`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<any>('post', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: shipmentData,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * Update shipment (Resource Permissions Required: ShipmentsView &amp;&amp; ShipmentsEdit)
   * @endpoint put /api/shipments
   * @param xTiveAccountId Account Id
   * @param shipmentData
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiShipmentsPut(
    xTiveAccountId?: number,
    shipmentData?: ShipmentData,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<any>;
  public apiShipmentsPut(
    xTiveAccountId?: number,
    shipmentData?: ShipmentData,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<any>>;
  public apiShipmentsPut(
    xTiveAccountId?: number,
    shipmentData?: ShipmentData,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<any>>;
  public apiShipmentsPut(
    xTiveAccountId?: number,
    shipmentData?: ShipmentData,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json;odata.metadata=minimal;odata.streaming=true',
      'application/json;odata.metadata=minimal;odata.streaming=false',
      'application/json;odata.metadata=minimal',
      'application/json;odata.metadata=full;odata.streaming=true',
      'application/json;odata.metadata=full;odata.streaming=false',
      'application/json;odata.metadata=full',
      'application/json;odata.metadata=none;odata.streaming=true',
      'application/json;odata.metadata=none;odata.streaming=false',
      'application/json;odata.metadata=none',
      'application/json;odata.streaming=true',
      'application/json;odata.streaming=false',
      'application/json',
      'application/xml',
      'text/plain',
      'application/json-patch+json',
      'text/json',
      'application/*+json',
    ];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/shipments`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<any>('put', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: shipmentData,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * Search shipments (Resource Permissions Required: ShipmentsView)
   * @endpoint get /api/shipments/search
   * @param searchTerm
   * @param xTiveAccountId Account Id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiShipmentsSearchGet(
    searchTerm?: string,
    xTiveAccountId?: number,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<Array<ShipmentSearch>>;
  public apiShipmentsSearchGet(
    searchTerm?: string,
    xTiveAccountId?: number,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<Array<ShipmentSearch>>>;
  public apiShipmentsSearchGet(
    searchTerm?: string,
    xTiveAccountId?: number,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<Array<ShipmentSearch>>>;
  public apiShipmentsSearchGet(
    searchTerm?: string,
    xTiveAccountId?: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'searchTerm',
      <any>searchTerm,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept([
        'application/json;odata.metadata=minimal;odata.streaming=true',
        'application/json;odata.metadata=minimal;odata.streaming=false',
        'application/json;odata.metadata=minimal',
        'application/json;odata.metadata=full;odata.streaming=true',
        'application/json;odata.metadata=full;odata.streaming=false',
        'application/json;odata.metadata=full',
        'application/json;odata.metadata=none;odata.streaming=true',
        'application/json;odata.metadata=none;odata.streaming=false',
        'application/json;odata.metadata=none',
        'application/json;odata.streaming=true',
        'application/json;odata.streaming=false',
        'application/json',
        'application/xml',
        'text/plain',
        'application/octet-stream',
        'text/json',
      ]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/shipments/search`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<Array<ShipmentSearch>>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters.toHttpParams(),
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * Set the carrier for a leg. (Resource Permissions Required: ShipmentsView &amp;&amp; ShipmentsEdit)
   * @endpoint put /api/shipments/set-carrier
   * @param legId The leg to modify
   * @param carrierId The carrier ID to set to.
   * @param xTiveAccountId Account Id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiShipmentsSetCarrierPut(
    legId?: number,
    carrierId?: string,
    xTiveAccountId?: number,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<any>;
  public apiShipmentsSetCarrierPut(
    legId?: number,
    carrierId?: string,
    xTiveAccountId?: number,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<any>>;
  public apiShipmentsSetCarrierPut(
    legId?: number,
    carrierId?: string,
    xTiveAccountId?: number,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<any>>;
  public apiShipmentsSetCarrierPut(
    legId?: number,
    carrierId?: string,
    xTiveAccountId?: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'legId',
      <any>legId,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'carrierId',
      <any>carrierId,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/shipments/set-carrier`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<any>('put', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters.toHttpParams(),
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * Set the start delay for a shipment. (Resource Permissions Required: ShipmentsView &amp;&amp; ShipmentsEdit)
   * @endpoint put /api/shipments/set-start-delay
   * @param internalShipmentId The shipment to modify.
   * @param startDelayDurationSeconds The delay to set in seconds.
   * @param xTiveAccountId Account Id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiShipmentsSetStartDelayPut(
    internalShipmentId?: string,
    startDelayDurationSeconds?: number,
    xTiveAccountId?: number,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<any>;
  public apiShipmentsSetStartDelayPut(
    internalShipmentId?: string,
    startDelayDurationSeconds?: number,
    xTiveAccountId?: number,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<any>>;
  public apiShipmentsSetStartDelayPut(
    internalShipmentId?: string,
    startDelayDurationSeconds?: number,
    xTiveAccountId?: number,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<any>>;
  public apiShipmentsSetStartDelayPut(
    internalShipmentId?: string,
    startDelayDurationSeconds?: number,
    xTiveAccountId?: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'internalShipmentId',
      <any>internalShipmentId,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'startDelayDurationSeconds',
      <any>startDelayDurationSeconds,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/shipments/set-start-delay`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<any>('put', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters.toHttpParams(),
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * Download attachment of the shipment
   * @endpoint get /api/shipments/shipmentAttachment/{publicShipmentId}
   * @param publicShipmentId
   * @param xTiveAccountId Account Id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiShipmentsShipmentAttachmentPublicShipmentIdGet(
    publicShipmentId: string,
    xTiveAccountId?: number,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<any>;
  public apiShipmentsShipmentAttachmentPublicShipmentIdGet(
    publicShipmentId: string,
    xTiveAccountId?: number,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<any>>;
  public apiShipmentsShipmentAttachmentPublicShipmentIdGet(
    publicShipmentId: string,
    xTiveAccountId?: number,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<any>>;
  public apiShipmentsShipmentAttachmentPublicShipmentIdGet(
    publicShipmentId: string,
    xTiveAccountId?: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    if (publicShipmentId === null || publicShipmentId === undefined) {
      throw new Error(
        'Required parameter publicShipmentId was null or undefined when calling apiShipmentsShipmentAttachmentPublicShipmentIdGet.',
      );
    }

    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/shipments/shipmentAttachment/${this.configuration.encodeParam({ name: 'publicShipmentId', value: publicShipmentId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<any>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * gets batch info given a batch id (Resource Permissions Required: ShipmentsView)
   * @endpoint get /api/shipments/shipmentBatchById
   * @param batchId
   * @param xTiveAccountId Account Id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiShipmentsShipmentBatchByIdGet(
    batchId?: number,
    xTiveAccountId?: number,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<any>;
  public apiShipmentsShipmentBatchByIdGet(
    batchId?: number,
    xTiveAccountId?: number,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<any>>;
  public apiShipmentsShipmentBatchByIdGet(
    batchId?: number,
    xTiveAccountId?: number,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<any>>;
  public apiShipmentsShipmentBatchByIdGet(
    batchId?: number,
    xTiveAccountId?: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'batchId',
      <any>batchId,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/shipments/shipmentBatchById`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<any>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters.toHttpParams(),
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * gets batch details i.e. list of shipments created in bulk per batch(csv file upload) (Resource Permissions Required: ShipmentsView)
   * @endpoint get /api/shipments/shipmentBatchDetail
   * @param batchId
   * @param xTiveAccountId Account Id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiShipmentsShipmentBatchDetailGet(
    batchId?: number,
    xTiveAccountId?: number,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<any>;
  public apiShipmentsShipmentBatchDetailGet(
    batchId?: number,
    xTiveAccountId?: number,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<any>>;
  public apiShipmentsShipmentBatchDetailGet(
    batchId?: number,
    xTiveAccountId?: number,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<any>>;
  public apiShipmentsShipmentBatchDetailGet(
    batchId?: number,
    xTiveAccountId?: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'batchId',
      <any>batchId,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/shipments/shipmentBatchDetail`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<any>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters.toHttpParams(),
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * gets a list of batches per customer used for creating shipments in bulk (Resource Permissions Required: ShipmentsView)
   * @endpoint get /api/shipments/shipmentBatches
   * @param xTiveAccountId Account Id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiShipmentsShipmentBatchesGet(
    xTiveAccountId?: number,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<any>;
  public apiShipmentsShipmentBatchesGet(
    xTiveAccountId?: number,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<any>>;
  public apiShipmentsShipmentBatchesGet(
    xTiveAccountId?: number,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<any>>;
  public apiShipmentsShipmentBatchesGet(
    xTiveAccountId?: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/shipments/shipmentBatches`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<any>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * Retrieve a shipment by a commentId for a shipment or alert comment (Resource Permissions Required: ViewShipmentAndAlertComments)
   * @endpoint get /api/shipments/shipment-by-comment
   * @param commentId
   * @param xTiveAccountId Account Id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiShipmentsShipmentByCommentGet(
    commentId?: string,
    xTiveAccountId?: number,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<ShipmentData>;
  public apiShipmentsShipmentByCommentGet(
    commentId?: string,
    xTiveAccountId?: number,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<ShipmentData>>;
  public apiShipmentsShipmentByCommentGet(
    commentId?: string,
    xTiveAccountId?: number,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<ShipmentData>>;
  public apiShipmentsShipmentByCommentGet(
    commentId?: string,
    xTiveAccountId?: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'commentId',
      <any>commentId,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept([
        'application/json;odata.metadata=minimal;odata.streaming=true',
        'application/json;odata.metadata=minimal;odata.streaming=false',
        'application/json;odata.metadata=minimal',
        'application/json;odata.metadata=full;odata.streaming=true',
        'application/json;odata.metadata=full;odata.streaming=false',
        'application/json;odata.metadata=full',
        'application/json;odata.metadata=none;odata.streaming=true',
        'application/json;odata.metadata=none;odata.streaming=false',
        'application/json;odata.metadata=none',
        'application/json;odata.streaming=true',
        'application/json;odata.streaming=false',
        'application/json',
        'application/xml',
        'text/plain',
        'application/octet-stream',
        'text/json',
      ]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/shipments/shipment-by-comment`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<ShipmentData>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters.toHttpParams(),
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * Checks if a shipment with the provided shipmentId exists (Resource Permissions Required: ShipmentsView)
   * @endpoint get /api/shipments/shipment-exists
   * @param shipmentId
   * @param xTiveAccountId Account Id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiShipmentsShipmentExistsGet(
    shipmentId?: string,
    xTiveAccountId?: number,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<boolean>;
  public apiShipmentsShipmentExistsGet(
    shipmentId?: string,
    xTiveAccountId?: number,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<boolean>>;
  public apiShipmentsShipmentExistsGet(
    shipmentId?: string,
    xTiveAccountId?: number,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<boolean>>;
  public apiShipmentsShipmentExistsGet(
    shipmentId?: string,
    xTiveAccountId?: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'shipmentId',
      <any>shipmentId,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept([
        'application/json;odata.metadata=minimal;odata.streaming=true',
        'application/json;odata.metadata=minimal;odata.streaming=false',
        'application/json;odata.metadata=minimal',
        'application/json;odata.metadata=full;odata.streaming=true',
        'application/json;odata.metadata=full;odata.streaming=false',
        'application/json;odata.metadata=full',
        'application/json;odata.metadata=none;odata.streaming=true',
        'application/json;odata.metadata=none;odata.streaming=false',
        'application/json;odata.metadata=none',
        'application/json;odata.streaming=true',
        'application/json;odata.streaming=false',
        'application/json',
        'application/xml',
        'text/plain',
        'application/octet-stream',
        'text/json',
      ]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/shipments/shipment-exists`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<boolean>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters.toHttpParams(),
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * Revoke existing shipment shared links - accessible only by shipment owner (Resource Permissions Required: ShipmentsView &amp;&amp; ShipmentsRevokeSharing)
   * @endpoint put /api/shipments/{shipmentId}/revokeSharedLinks
   * @param shipmentId
   * @param xTiveAccountId Account Id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiShipmentsShipmentIdRevokeSharedLinksPut(
    shipmentId: string,
    xTiveAccountId?: number,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<any>;
  public apiShipmentsShipmentIdRevokeSharedLinksPut(
    shipmentId: string,
    xTiveAccountId?: number,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<any>>;
  public apiShipmentsShipmentIdRevokeSharedLinksPut(
    shipmentId: string,
    xTiveAccountId?: number,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<any>>;
  public apiShipmentsShipmentIdRevokeSharedLinksPut(
    shipmentId: string,
    xTiveAccountId?: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    if (shipmentId === null || shipmentId === undefined) {
      throw new Error(
        'Required parameter shipmentId was null or undefined when calling apiShipmentsShipmentIdRevokeSharedLinksPut.',
      );
    }

    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/shipments/${this.configuration.encodeParam({ name: 'shipmentId', value: shipmentId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/revokeSharedLinks`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<any>('put', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * Get Shared Shipment Links for current user (Resource Permissions Required: ShipmentsView &amp;&amp; ShipmentsShare)
   * @endpoint get /api/shipments/{shipmentId}/sharedShipmentLinks
   * @param shipmentId
   * @param xTiveAccountId Account Id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiShipmentsShipmentIdSharedShipmentLinksGet(
    shipmentId: string,
    xTiveAccountId?: number,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<any>;
  public apiShipmentsShipmentIdSharedShipmentLinksGet(
    shipmentId: string,
    xTiveAccountId?: number,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<any>>;
  public apiShipmentsShipmentIdSharedShipmentLinksGet(
    shipmentId: string,
    xTiveAccountId?: number,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<any>>;
  public apiShipmentsShipmentIdSharedShipmentLinksGet(
    shipmentId: string,
    xTiveAccountId?: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    if (shipmentId === null || shipmentId === undefined) {
      throw new Error(
        'Required parameter shipmentId was null or undefined when calling apiShipmentsShipmentIdSharedShipmentLinksGet.',
      );
    }

    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/shipments/${this.configuration.encodeParam({ name: 'shipmentId', value: shipmentId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/sharedShipmentLinks`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<any>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * Upsert a public shipment sharing link (Resource Permissions Required: ShipmentsView &amp;&amp; ShipmentsShare)
   * @endpoint post /api/shipments/{shipmentId}/sharing
   * @param shipmentId
   * @param xTiveAccountId Account Id
   * @param shipmentPublicShare
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiShipmentsShipmentIdSharingPost(
    shipmentId: string,
    xTiveAccountId?: number,
    shipmentPublicShare?: ShipmentPublicShare,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<any>;
  public apiShipmentsShipmentIdSharingPost(
    shipmentId: string,
    xTiveAccountId?: number,
    shipmentPublicShare?: ShipmentPublicShare,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<any>>;
  public apiShipmentsShipmentIdSharingPost(
    shipmentId: string,
    xTiveAccountId?: number,
    shipmentPublicShare?: ShipmentPublicShare,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<any>>;
  public apiShipmentsShipmentIdSharingPost(
    shipmentId: string,
    xTiveAccountId?: number,
    shipmentPublicShare?: ShipmentPublicShare,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    if (shipmentId === null || shipmentId === undefined) {
      throw new Error(
        'Required parameter shipmentId was null or undefined when calling apiShipmentsShipmentIdSharingPost.',
      );
    }

    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json;odata.metadata=minimal;odata.streaming=true',
      'application/json;odata.metadata=minimal;odata.streaming=false',
      'application/json;odata.metadata=minimal',
      'application/json;odata.metadata=full;odata.streaming=true',
      'application/json;odata.metadata=full;odata.streaming=false',
      'application/json;odata.metadata=full',
      'application/json;odata.metadata=none;odata.streaming=true',
      'application/json;odata.metadata=none;odata.streaming=false',
      'application/json;odata.metadata=none',
      'application/json;odata.streaming=true',
      'application/json;odata.streaming=false',
      'application/json',
      'application/xml',
      'text/plain',
      'application/json-patch+json',
      'text/json',
      'application/*+json',
    ];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/shipments/${this.configuration.encodeParam({ name: 'shipmentId', value: shipmentId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/sharing`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<any>('post', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: shipmentPublicShare,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * Check if shared links exist for this shipment, for any other user.  Useful to know if this user could/should be able to revoke all sharing for the shipment (Resource Permissions Required: ShipmentsView &amp;&amp; ShipmentsRevokeSharing)
   * @endpoint get /api/shipments/{shipmentId}/sharingRevocable
   * @param shipmentId
   * @param xTiveAccountId Account Id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiShipmentsShipmentIdSharingRevocableGet(
    shipmentId: string,
    xTiveAccountId?: number,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<boolean>;
  public apiShipmentsShipmentIdSharingRevocableGet(
    shipmentId: string,
    xTiveAccountId?: number,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<boolean>>;
  public apiShipmentsShipmentIdSharingRevocableGet(
    shipmentId: string,
    xTiveAccountId?: number,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<boolean>>;
  public apiShipmentsShipmentIdSharingRevocableGet(
    shipmentId: string,
    xTiveAccountId?: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    if (shipmentId === null || shipmentId === undefined) {
      throw new Error(
        'Required parameter shipmentId was null or undefined when calling apiShipmentsShipmentIdSharingRevocableGet.',
      );
    }

    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept([
        'application/json;odata.metadata=minimal;odata.streaming=true',
        'application/json;odata.metadata=minimal;odata.streaming=false',
        'application/json;odata.metadata=minimal',
        'application/json;odata.metadata=full;odata.streaming=true',
        'application/json;odata.metadata=full;odata.streaming=false',
        'application/json;odata.metadata=full',
        'application/json;odata.metadata=none;odata.streaming=true',
        'application/json;odata.metadata=none;odata.streaming=false',
        'application/json;odata.metadata=none',
        'application/json;odata.streaming=true',
        'application/json;odata.streaming=false',
        'application/json',
        'application/xml',
        'text/plain',
        'application/octet-stream',
        'text/json',
      ]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/shipments/${this.configuration.encodeParam({ name: 'shipmentId', value: shipmentId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/sharingRevocable`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<boolean>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * Get monitoring lite config for a shipment (Resource Permissions Required: ShipmentsView)
   * @endpoint get /api/shipments/shipmentMonitoringConfig
   * @param internalShipmentId
   * @param xTiveAccountId Account Id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiShipmentsShipmentMonitoringConfigGet(
    internalShipmentId?: string,
    xTiveAccountId?: number,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<AccountMonitoringConfig>;
  public apiShipmentsShipmentMonitoringConfigGet(
    internalShipmentId?: string,
    xTiveAccountId?: number,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<AccountMonitoringConfig>>;
  public apiShipmentsShipmentMonitoringConfigGet(
    internalShipmentId?: string,
    xTiveAccountId?: number,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<AccountMonitoringConfig>>;
  public apiShipmentsShipmentMonitoringConfigGet(
    internalShipmentId?: string,
    xTiveAccountId?: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'internalShipmentId',
      <any>internalShipmentId,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept([
        'application/json;odata.metadata=minimal;odata.streaming=true',
        'application/json;odata.metadata=minimal;odata.streaming=false',
        'application/json;odata.metadata=minimal',
        'application/json;odata.metadata=full;odata.streaming=true',
        'application/json;odata.metadata=full;odata.streaming=false',
        'application/json;odata.metadata=full',
        'application/json;odata.metadata=none;odata.streaming=true',
        'application/json;odata.metadata=none;odata.streaming=false',
        'application/json;odata.metadata=none',
        'application/json;odata.streaming=true',
        'application/json;odata.streaming=false',
        'application/json',
        'application/xml',
        'text/plain',
        'application/octet-stream',
        'text/json',
      ]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/shipments/shipmentMonitoringConfig`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<AccountMonitoringConfig>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters.toHttpParams(),
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * Start shipment (Resource Permissions Required: (ShipmentsStart || ShipmentsSchedule) &amp;&amp; (ShipmentsView))
   * @endpoint put /api/shipments/start
   * @param internalShipmentId
   * @param trackerId
   * @param trackerIds
   * @param skipCheckingForLocation
   * @param closeActiveShipments
   * @param startNow
   * @param xTiveAccountId Account Id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiShipmentsStartPut(
    internalShipmentId?: string,
    trackerId?: string,
    trackerIds?: Array<string>,
    skipCheckingForLocation?: boolean,
    closeActiveShipments?: boolean,
    startNow?: boolean,
    xTiveAccountId?: number,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<any>;
  public apiShipmentsStartPut(
    internalShipmentId?: string,
    trackerId?: string,
    trackerIds?: Array<string>,
    skipCheckingForLocation?: boolean,
    closeActiveShipments?: boolean,
    startNow?: boolean,
    xTiveAccountId?: number,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<any>>;
  public apiShipmentsStartPut(
    internalShipmentId?: string,
    trackerId?: string,
    trackerIds?: Array<string>,
    skipCheckingForLocation?: boolean,
    closeActiveShipments?: boolean,
    startNow?: boolean,
    xTiveAccountId?: number,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<any>>;
  public apiShipmentsStartPut(
    internalShipmentId?: string,
    trackerId?: string,
    trackerIds?: Array<string>,
    skipCheckingForLocation?: boolean,
    closeActiveShipments?: boolean,
    startNow?: boolean,
    xTiveAccountId?: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'internalShipmentId',
      <any>internalShipmentId,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'trackerId',
      <any>trackerId,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'trackerIds',
      <any>trackerIds,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'skipCheckingForLocation',
      <any>skipCheckingForLocation,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'closeActiveShipments',
      <any>closeActiveShipments,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'startNow',
      <any>startNow,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/shipments/start`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<any>('put', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters.toHttpParams(),
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * Starts a previously schedule shipment. (Resource Permissions Required: ShipmentsView &amp;&amp; ShipmentsStart)
   * @endpoint put /api/shipments/startScheduled
   * @param internalShipmentId
   * @param startTime
   * @param xTiveAccountId Account Id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiShipmentsStartScheduledPut(
    internalShipmentId?: string,
    startTime?: string,
    xTiveAccountId?: number,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<any>;
  public apiShipmentsStartScheduledPut(
    internalShipmentId?: string,
    startTime?: string,
    xTiveAccountId?: number,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<any>>;
  public apiShipmentsStartScheduledPut(
    internalShipmentId?: string,
    startTime?: string,
    xTiveAccountId?: number,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<any>>;
  public apiShipmentsStartScheduledPut(
    internalShipmentId?: string,
    startTime?: string,
    xTiveAccountId?: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'internalShipmentId',
      <any>internalShipmentId,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'startTime',
      <any>startTime,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/shipments/startScheduled`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<any>('put', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters.toHttpParams(),
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * Get the status of a shipment (InTransit, Complete, NotStarted, Unknown)
   * @endpoint get /api/shipments/status
   * @param publicShipmentId Any shipment identifier (shipmentId, publicShipmentId, or internalShipmentId)
   * @param xTiveAccountId Account Id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiShipmentsStatusGet(
    publicShipmentId?: string,
    xTiveAccountId?: number,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<ShipmentStatus>;
  public apiShipmentsStatusGet(
    publicShipmentId?: string,
    xTiveAccountId?: number,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<ShipmentStatus>>;
  public apiShipmentsStatusGet(
    publicShipmentId?: string,
    xTiveAccountId?: number,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<ShipmentStatus>>;
  public apiShipmentsStatusGet(
    publicShipmentId?: string,
    xTiveAccountId?: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'publicShipmentId',
      <any>publicShipmentId,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept([
        'application/json;odata.metadata=minimal;odata.streaming=true',
        'application/json;odata.metadata=minimal;odata.streaming=false',
        'application/json;odata.metadata=minimal',
        'application/json;odata.metadata=full;odata.streaming=true',
        'application/json;odata.metadata=full;odata.streaming=false',
        'application/json;odata.metadata=full',
        'application/json;odata.metadata=none;odata.streaming=true',
        'application/json;odata.metadata=none;odata.streaming=false',
        'application/json;odata.metadata=none',
        'application/json;odata.streaming=true',
        'application/json;odata.streaming=false',
        'application/json',
        'application/xml',
        'text/plain',
        'application/octet-stream',
        'text/json',
      ]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/shipments/status`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<ShipmentStatus>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters.toHttpParams(),
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * Get shipments [Ship To] list (Resource Permissions Required: ShipmentsView)
   * @endpoint get /api/shipments/tolist
   * @param shipmentGroup 1 &#x3D; Upcoming, 2 &#x3D; Active, 3 &#x3D; Completed. Leave empty for all
   * @param xTiveAccountId Account Id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiShipmentsTolistGet(
    shipmentGroup?: number,
    xTiveAccountId?: number,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<Array<CityCountryDataItem>>;
  public apiShipmentsTolistGet(
    shipmentGroup?: number,
    xTiveAccountId?: number,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<Array<CityCountryDataItem>>>;
  public apiShipmentsTolistGet(
    shipmentGroup?: number,
    xTiveAccountId?: number,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<Array<CityCountryDataItem>>>;
  public apiShipmentsTolistGet(
    shipmentGroup?: number,
    xTiveAccountId?: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'shipmentGroup',
      <any>shipmentGroup,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept([
        'application/json;odata.metadata=minimal;odata.streaming=true',
        'application/json;odata.metadata=minimal;odata.streaming=false',
        'application/json;odata.metadata=minimal',
        'application/json;odata.metadata=full;odata.streaming=true',
        'application/json;odata.metadata=full;odata.streaming=false',
        'application/json;odata.metadata=full',
        'application/json;odata.metadata=none;odata.streaming=true',
        'application/json;odata.metadata=none;odata.streaming=false',
        'application/json;odata.metadata=none',
        'application/json;odata.streaming=true',
        'application/json;odata.streaming=false',
        'application/json',
        'application/xml',
        'text/plain',
        'application/octet-stream',
        'text/json',
      ]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/shipments/tolist`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<Array<CityCountryDataItem>>(
      'get',
      `${basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters.toHttpParams(),
        responseType: <any>responseType_,
        ...(withCredentials ? { withCredentials } : {}),
        headers: localVarHeaders,
        observe: observe,
        ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Get trackers to list for creating or updating shipment
   * @endpoint get /api/shipments/trackers
   * @param xTiveAccountId Account Id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiShipmentsTrackersGet(
    xTiveAccountId?: number,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<any>;
  public apiShipmentsTrackersGet(
    xTiveAccountId?: number,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<any>>;
  public apiShipmentsTrackersGet(
    xTiveAccountId?: number,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<any>>;
  public apiShipmentsTrackersGet(
    xTiveAccountId?: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/shipments/trackers`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<any>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * Get paged list of available trackers for creating or updating a shipment
   * @endpoint get /api/shipments/trackersPaged
   * @param pageSize
   * @param pageNumber
   * @param xTiveAccountId Account Id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiShipmentsTrackersPagedGet(
    pageSize?: number,
    pageNumber?: number,
    xTiveAccountId?: number,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<any>;
  public apiShipmentsTrackersPagedGet(
    pageSize?: number,
    pageNumber?: number,
    xTiveAccountId?: number,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<any>>;
  public apiShipmentsTrackersPagedGet(
    pageSize?: number,
    pageNumber?: number,
    xTiveAccountId?: number,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<any>>;
  public apiShipmentsTrackersPagedGet(
    pageSize?: number,
    pageNumber?: number,
    xTiveAccountId?: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'pageSize',
      <any>pageSize,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'pageNumber',
      <any>pageNumber,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/shipments/trackersPaged`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<any>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters.toHttpParams(),
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * Sets trackers for the specified shipment (Resource Permissions Required: ShipmentsAddTracker)
   * @endpoint put /api/shipments/trackers
   * @param skipLocationCheck
   * @param closeActiveShipments
   * @param closeActiveShipmentsAtUtc
   * @param xTiveAccountId Account Id
   * @param shipmentData
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiShipmentsTrackersPut(
    skipLocationCheck?: boolean,
    closeActiveShipments?: boolean,
    closeActiveShipmentsAtUtc?: string,
    xTiveAccountId?: number,
    shipmentData?: ShipmentData,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<any>;
  public apiShipmentsTrackersPut(
    skipLocationCheck?: boolean,
    closeActiveShipments?: boolean,
    closeActiveShipmentsAtUtc?: string,
    xTiveAccountId?: number,
    shipmentData?: ShipmentData,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<any>>;
  public apiShipmentsTrackersPut(
    skipLocationCheck?: boolean,
    closeActiveShipments?: boolean,
    closeActiveShipmentsAtUtc?: string,
    xTiveAccountId?: number,
    shipmentData?: ShipmentData,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<any>>;
  public apiShipmentsTrackersPut(
    skipLocationCheck?: boolean,
    closeActiveShipments?: boolean,
    closeActiveShipmentsAtUtc?: string,
    xTiveAccountId?: number,
    shipmentData?: ShipmentData,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'skipLocationCheck',
      <any>skipLocationCheck,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'closeActiveShipments',
      <any>closeActiveShipments,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'closeActiveShipmentsAtUtc',
      <any>closeActiveShipmentsAtUtc,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json;odata.metadata=minimal;odata.streaming=true',
      'application/json;odata.metadata=minimal;odata.streaming=false',
      'application/json;odata.metadata=minimal',
      'application/json;odata.metadata=full;odata.streaming=true',
      'application/json;odata.metadata=full;odata.streaming=false',
      'application/json;odata.metadata=full',
      'application/json;odata.metadata=none;odata.streaming=true',
      'application/json;odata.metadata=none;odata.streaming=false',
      'application/json;odata.metadata=none',
      'application/json;odata.streaming=true',
      'application/json;odata.streaming=false',
      'application/json',
      'application/xml',
      'text/plain',
      'application/json-patch+json',
      'text/json',
      'application/*+json',
    ];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/shipments/trackers`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<any>('put', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: shipmentData,
      params: localVarQueryParameters.toHttpParams(),
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * Uploads a shipment attachment (Resource Permissions Required: ShipmentsView &amp;&amp; ShipmentsEdit)
   * @endpoint post /api/shipments/uploadShipmentAttachmentAsCollaborator
   * @param filename
   * @param internalShipmentId
   * @param xTiveAccountId Account Id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiShipmentsUploadShipmentAttachmentAsCollaboratorPost(
    filename?: string,
    internalShipmentId?: string,
    xTiveAccountId?: number,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<string>;
  public apiShipmentsUploadShipmentAttachmentAsCollaboratorPost(
    filename?: string,
    internalShipmentId?: string,
    xTiveAccountId?: number,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<string>>;
  public apiShipmentsUploadShipmentAttachmentAsCollaboratorPost(
    filename?: string,
    internalShipmentId?: string,
    xTiveAccountId?: number,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<string>>;
  public apiShipmentsUploadShipmentAttachmentAsCollaboratorPost(
    filename?: string,
    internalShipmentId?: string,
    xTiveAccountId?: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'filename',
      <any>filename,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'internalShipmentId',
      <any>internalShipmentId,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept([
        'application/json;odata.metadata=minimal;odata.streaming=true',
        'application/json;odata.metadata=minimal;odata.streaming=false',
        'application/json;odata.metadata=minimal',
        'application/json;odata.metadata=full;odata.streaming=true',
        'application/json;odata.metadata=full;odata.streaming=false',
        'application/json;odata.metadata=full',
        'application/json;odata.metadata=none;odata.streaming=true',
        'application/json;odata.metadata=none;odata.streaming=false',
        'application/json;odata.metadata=none',
        'application/json;odata.streaming=true',
        'application/json;odata.streaming=false',
        'application/json',
        'application/xml',
        'text/plain',
        'application/octet-stream',
        'text/json',
      ]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/shipments/uploadShipmentAttachmentAsCollaborator`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<string>('post', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters.toHttpParams(),
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * Uploads a shipment attachment
   * @endpoint post /api/shipments/uploadShipmentAttachment
   * @param filename
   * @param xTiveAccountId Account Id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiShipmentsUploadShipmentAttachmentPost(
    filename?: string,
    xTiveAccountId?: number,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<string>;
  public apiShipmentsUploadShipmentAttachmentPost(
    filename?: string,
    xTiveAccountId?: number,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<string>>;
  public apiShipmentsUploadShipmentAttachmentPost(
    filename?: string,
    xTiveAccountId?: number,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<string>>;
  public apiShipmentsUploadShipmentAttachmentPost(
    filename?: string,
    xTiveAccountId?: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'filename',
      <any>filename,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept([
        'application/json;odata.metadata=minimal;odata.streaming=true',
        'application/json;odata.metadata=minimal;odata.streaming=false',
        'application/json;odata.metadata=minimal',
        'application/json;odata.metadata=full;odata.streaming=true',
        'application/json;odata.metadata=full;odata.streaming=false',
        'application/json;odata.metadata=full',
        'application/json;odata.metadata=none;odata.streaming=true',
        'application/json;odata.metadata=none;odata.streaming=false',
        'application/json;odata.metadata=none',
        'application/json;odata.streaming=true',
        'application/json;odata.streaming=false',
        'application/json',
        'application/xml',
        'text/plain',
        'application/octet-stream',
        'text/json',
      ]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/shipments/uploadShipmentAttachment`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<string>('post', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters.toHttpParams(),
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * Gets user specific shipment configuration by configuration key
   * @endpoint get /api/shipments/userShipmentConfiguration
   * @param internalShipmentId
   * @param configurationKey
   * @param xTiveAccountId Account Id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiShipmentsUserShipmentConfigurationGet(
    internalShipmentId?: string,
    configurationKey?: string,
    xTiveAccountId?: number,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<ShipmentUserConfigurationEntry>;
  public apiShipmentsUserShipmentConfigurationGet(
    internalShipmentId?: string,
    configurationKey?: string,
    xTiveAccountId?: number,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<ShipmentUserConfigurationEntry>>;
  public apiShipmentsUserShipmentConfigurationGet(
    internalShipmentId?: string,
    configurationKey?: string,
    xTiveAccountId?: number,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<ShipmentUserConfigurationEntry>>;
  public apiShipmentsUserShipmentConfigurationGet(
    internalShipmentId?: string,
    configurationKey?: string,
    xTiveAccountId?: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'internalShipmentId',
      <any>internalShipmentId,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'configurationKey',
      <any>configurationKey,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept([
        'application/json;odata.metadata=minimal;odata.streaming=true',
        'application/json;odata.metadata=minimal;odata.streaming=false',
        'application/json;odata.metadata=minimal',
        'application/json;odata.metadata=full;odata.streaming=true',
        'application/json;odata.metadata=full;odata.streaming=false',
        'application/json;odata.metadata=full',
        'application/json;odata.metadata=none;odata.streaming=true',
        'application/json;odata.metadata=none;odata.streaming=false',
        'application/json;odata.metadata=none',
        'application/json;odata.streaming=true',
        'application/json;odata.streaming=false',
        'application/json',
        'application/xml',
        'text/plain',
        'application/octet-stream',
        'text/json',
      ]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/shipments/userShipmentConfiguration`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<ShipmentUserConfigurationEntry>(
      'get',
      `${basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters.toHttpParams(),
        responseType: <any>responseType_,
        ...(withCredentials ? { withCredentials } : {}),
        headers: localVarHeaders,
        observe: observe,
        ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Updates or inserts user shipment configuration entry
   * @endpoint put /api/shipments/userShipmentConfiguration
   * @param internalShipmentId
   * @param xTiveAccountId Account Id
   * @param shipmentUserConfigurationEntry
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiShipmentsUserShipmentConfigurationPut(
    internalShipmentId?: string,
    xTiveAccountId?: number,
    shipmentUserConfigurationEntry?: ShipmentUserConfigurationEntry,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<any>;
  public apiShipmentsUserShipmentConfigurationPut(
    internalShipmentId?: string,
    xTiveAccountId?: number,
    shipmentUserConfigurationEntry?: ShipmentUserConfigurationEntry,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<any>>;
  public apiShipmentsUserShipmentConfigurationPut(
    internalShipmentId?: string,
    xTiveAccountId?: number,
    shipmentUserConfigurationEntry?: ShipmentUserConfigurationEntry,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<any>>;
  public apiShipmentsUserShipmentConfigurationPut(
    internalShipmentId?: string,
    xTiveAccountId?: number,
    shipmentUserConfigurationEntry?: ShipmentUserConfigurationEntry,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'internalShipmentId',
      <any>internalShipmentId,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json;odata.metadata=minimal;odata.streaming=true',
      'application/json;odata.metadata=minimal;odata.streaming=false',
      'application/json;odata.metadata=minimal',
      'application/json;odata.metadata=full;odata.streaming=true',
      'application/json;odata.metadata=full;odata.streaming=false',
      'application/json;odata.metadata=full',
      'application/json;odata.metadata=none;odata.streaming=true',
      'application/json;odata.metadata=none;odata.streaming=false',
      'application/json;odata.metadata=none',
      'application/json;odata.streaming=true',
      'application/json;odata.streaming=false',
      'application/json',
      'application/xml',
      'text/plain',
      'application/json-patch+json',
      'text/json',
      'application/*+json',
    ];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/shipments/userShipmentConfiguration`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<any>('put', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: shipmentUserConfigurationEntry,
      params: localVarQueryParameters.toHttpParams(),
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * Get users to list for creating or updating shipment (Role Permissions Required: ShipmentsView)
   * @endpoint get /api/shipments/users
   * @param xTiveAccountId Account Id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiShipmentsUsersGet(
    xTiveAccountId?: number,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<any>;
  public apiShipmentsUsersGet(
    xTiveAccountId?: number,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<any>>;
  public apiShipmentsUsersGet(
    xTiveAccountId?: number,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<any>>;
  public apiShipmentsUsersGet(
    xTiveAccountId?: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/shipments/users`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<any>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * Get the users (including collaborators) who can access specified shipment (Resource Permissions Required: ShipmentsViewAccess)
   * @endpoint get /api/shipments/users/{internalShipmentId}
   * @param internalShipmentId
   * @param searchTerm
   * @param xTiveAccountId Account Id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiShipmentsUsersInternalShipmentIdGet(
    internalShipmentId: string,
    searchTerm?: string,
    xTiveAccountId?: number,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<Array<User>>;
  public apiShipmentsUsersInternalShipmentIdGet(
    internalShipmentId: string,
    searchTerm?: string,
    xTiveAccountId?: number,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<Array<User>>>;
  public apiShipmentsUsersInternalShipmentIdGet(
    internalShipmentId: string,
    searchTerm?: string,
    xTiveAccountId?: number,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<Array<User>>>;
  public apiShipmentsUsersInternalShipmentIdGet(
    internalShipmentId: string,
    searchTerm?: string,
    xTiveAccountId?: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    if (internalShipmentId === null || internalShipmentId === undefined) {
      throw new Error(
        'Required parameter internalShipmentId was null or undefined when calling apiShipmentsUsersInternalShipmentIdGet.',
      );
    }

    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'searchTerm',
      <any>searchTerm,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept([
        'application/json;odata.metadata=minimal;odata.streaming=true',
        'application/json;odata.metadata=minimal;odata.streaming=false',
        'application/json;odata.metadata=minimal',
        'application/json;odata.metadata=full;odata.streaming=true',
        'application/json;odata.metadata=full;odata.streaming=false',
        'application/json;odata.metadata=full',
        'application/json;odata.metadata=none;odata.streaming=true',
        'application/json;odata.metadata=none;odata.streaming=false',
        'application/json;odata.metadata=none',
        'application/json;odata.streaming=true',
        'application/json;odata.streaming=false',
        'application/json',
        'application/xml',
        'text/plain',
        'application/octet-stream',
        'text/json',
      ]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/shipments/users/${this.configuration.encodeParam({ name: 'internalShipmentId', value: internalShipmentId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<Array<User>>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters.toHttpParams(),
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }
}
